'use client'

import { PropertiesTag } from '@graftcode/design-system'

import { MemberGraftabilityHint } from '@/core/components/MemberGraftabilityHint'
import type { MobileCardItem } from '@/core/types/cardNavigation.type'
import { getBadgeType } from '@/core/utils/getBadgeType'
import { getPropertiesTagVariant } from '@/core/utils/getPropertiesTagVariant'

import { NoResultsState } from '../../NoResultsState'

import styles from './ClassView.module.scss'

interface ClassViewListProps {
  searchQuery: string
  filteredCards: MobileCardItem[] | undefined
  onCardClick: (cardId: string) => void
}

export function ClassViewList({ searchQuery, filteredCards, onCardClick }: ClassViewListProps) {
  const hasSearch = searchQuery.trim().length > 0
  const isEmpty = !filteredCards || filteredCards.length === 0
  const showNoResults = hasSearch && isEmpty
  const getBadgeVariant = (badge: string) => getPropertiesTagVariant(getBadgeType(badge))

  return (
    <div className={styles.listContainer}>
      {showNoResults ? (
        <NoResultsState />
      ) : (
        filteredCards?.map((card: MobileCardItem) => (
          <div key={card.id} className={styles.mobileCard} onClick={() => onCardClick(card.id)}>
            {card.badge && (
              <PropertiesTag variant={getBadgeVariant(card.badge)} withoutIcon className={styles.mobileCardBadge}>
                {card.badge}
              </PropertiesTag>
            )}
            <div className={styles.mobileCardBody}>
              <span className={styles.mobileCardName}>
                {card.name}
                {card.graftabilityIssues && card.graftabilityIssues.length > 0 && (
                  <MemberGraftabilityHint issues={card.graftabilityIssues} />
                )}
              </span>
              {card.description && <span className={styles.mobileCardDescription}>{card.description}</span>}
            </div>
          </div>
        ))
      )}
    </div>
  )
}
